import CONFIG from '@config';

const getPlatform = () => {
  return CONFIG.algolia?.platform?.store || 'unknown-platform';
};

export default getPlatform;
